import { getAppConfigSetting } from "../utils";

// fixme these will change from "api" to "apiUrl" when the pr to correct forwarding happens

export const MISMATCHED_TRADES_API = `${getAppConfigSetting(
  "apiUrl"
)}/api/v1/occ-mismatches`;

export const MISBILLED_TRADES_API = `${getAppConfigSetting(
  "apiUrl"
)}/api/v1/occ-misbilled`;

export const WITH_CREDENTIALS_CONFIG = {
  withCredentials: true,
};
